var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfElementWot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1827,
    height: 2500,
    viewBox: "0 0 1827 2500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_259_13)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1622.31 530.458L1456.25 361.863L1277.95 185.573H549.048L375.372 361.863L209.312 530.458H740.705V2053.28L915.824 2226.45L1090.91 2053.28V530.458H1090.94H1622.31Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1450.17 695.241H1283V1374.7L1108.35 1547.27L1231.34 1666.68L1355.55 1787.33L1622.84 1523.01L1622.9 695.241H1450.17ZM548.679 1374.7V695.241H208.738V1523.01L476.132 1787.33L600.347 1666.68L723.26 1547.27L548.679 1374.7Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.85 92.7389L92.6843 522.711V1564.95L913.523 2370.49L1734.33 1564.95V522.743L1304.18 92.7389H522.85ZM13.7349 470.846L471.252 13.7697L484.785 0.140625H1342.19L1355.72 13.7697L1813.27 470.846L1827 484.601V1603.44L1813.1 1617.05L945.901 2468.1L913.525 2499.86L881.106 2468.1L13.9417 1617.06L0 1603.44V484.609L13.7349 470.846Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_259_13"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1827,
    height: 2500,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfElementWot);
export default __webpack_public_path__ + "static/media/inf-element-wot.387d326f51bb1c57cddceb505e3327cc.svg";
export { ForwardRef as ReactComponent };